import { render, staticRenderFns } from "./InterventionsProcedure.vue?vue&type=template&id=6746ba14&scoped=true"
import script from "./InterventionsProcedure.vue?vue&type=script&lang=js"
export * from "./InterventionsProcedure.vue?vue&type=script&lang=js"
import style0 from "./InterventionsProcedure.vue?vue&type=style&index=0&id=6746ba14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6746ba14",
  null
  
)

export default component.exports